import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../../components/loaderComponent/Loding";
import CommonHeader from "../../../components/common/commonHeader/CommonHeader";
import { getMyStudyPacks } from "../../../apiCalls/userApiCalls";
import { SubjectPagePDFItem } from "../../../components/Subject-page/SubjectPagePDFItem";
import StudyPackHeader from "../../../components/common/studyPackHeader/StudyPackHeader";


export const StudypackTutesPage = () => {
  const location = useLocation();
  const { state } = location;
  const dispatch = useDispatch();
  const studyPackUser = JSON.parse(sessionStorage.getItem("studyPackUser"));

  React.useEffect(() => {
    if (state?.lesson?.subject) {
      const data = {
        subject: state.lesson.subject,
        studypackUserId: studyPackUser._id,
      };
      getMyStudyPacks(data, dispatch);
    }
  }, [state?.lesson]);

  const isLoading = useSelector((state) => state.studyPack.isFetching);
  const studyPacks = useSelector((state) => state.studyPack.studyPacks);

  const studyPack = studyPacks.find(obj => obj._id === state?.lesson?._id);

  return (
    <React.Fragment>
       <StudyPackHeader />
      <Box sx={{ width: "100%", height: "80px" }}></Box>
      {isLoading ? (
        <Loader />
      ) : (
        <>
        
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Typography
              variant="h3"
              sx={{ fontWeight: 700, fontFamily: "Noto Sans Sinhala" }}
            >
              {state?.lesson?.name}
            </Typography>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              mt={5}
            >
              {studyPack?.tutes?.length > 0 ? (
                studyPack?.tutes.map((pdf, index) => {
                  return (
                    <Grid key={index} item xs={12} sm={6} md={6} lg={4}>
                      <SubjectPagePDFItem pdf={pdf} />
                    </Grid>
                  );
                })
              ) : (
                <Grid
                  container
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  justifyContent={"center"}
                >
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 400, marginTop: "100px" }}
                  >
                    No Lessons
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Box>
        </>
      )}
    </React.Fragment>
  );
};
